<template>
  <div class="agenceFilter">
    <div class="agenceFilter__title">Filtres</div>
    <label for="month-select" class="agenceFilter__labels">Mois</label>
    <select name="month" id="month-select" class="month-selector" @change="onChange">
      <option value ="all" selected>Tous les mois</option>
      <option v-for="month in monthList" :key=month.value :value=month.id>{{ month.value  }}</option>
    </select>
    <label for="month-agence-ops-input" class="agenceFilter__labels">Opération</label>
    <SearchPredictiveProject class="search" borderRadius="5px" :placeholder="'Rechercher...'" :arraySearch="arrayForSearch" @result="processValue" @resetProject = "resetProject"/>
    <label for="phases" class="agenceFilter__labels">Phase</label>
    <select name="phases" id="phase" class="phase-selector" ref="phase" @change="onChange">
      <option value ="all" selected>Toutes les phases</option>
      <option v-for="phase in phaseList" :key="phase.name" :value="phase._id">{{ phase.name }}</option>
    </select>
    <label for="Collaborator-select" class="agenceFilter__labels">Collaborateurs</label>
    <select class="collaborator-input" type="collaborator" @change="onChange">
      <option value ="allCollaborators" selected>Tous les collaborateurs</option>
      <option v-for="collaborator in collaboratorHandler" :key = collaborator.id :value =collaborator.id>
        {{ collaborator.nameSurname }}
      </option>
    </select>
    <button @click="processPayload" class="agenceFilter__button">Valider</button>
  </div>
</template>

<script>
import SearchPredictiveProject from "@/components/SearchPredictiveProject";

export default {
  name: "AgenceFilter",
  components:{
    SearchPredictiveProject
  },
  props: {
    year: Number
  },

  data(){
    return{
      monthList: [
        {id:0, value:'Janvier'},
        {id:1, value:'Février'},
        {id:2, value:'Mars'},
        {id:3, value:'Avril'},
        {id:4, value:'Mai'},
        {id:5, value:'Juin'},
        {id:6, value:'Juillet'},
        {id:7, value:'Août'},
        {id:8, value:'Septembre'},
        {id:9, value:'Octobre'},
        {id:10, value:'Novembre'},
        {id:11, value:'Décembre'}],
      payload:{
        agenceId: "",
        month: "all",
        projectId: "all",
        phase:"all",
        collaboratorId: "all",

      },
      placeholder: '',
      phaseList: [],
      opsList:[],
      collaborator:[],
      avgFacturable:0,
    }
  },
  mounted() {
    this.loadYear();
  },
  computed:{
    arrayForSearch(){
      let array = []
      if(this.opsList.length > 0){
        for ( let i = 0; i < this.opsList.length; i++){
          let item = {
            _id: this.opsList[i]._id,
            name: this.opsList[i].name
          }
          array.push(item)
        }
      }
      // else {
      //   console.log("array is empty")
      // }
      return array
    },
    collaboratorHandler(){
      let collaboratorList = new Array()
      for(let i =0; i<this.collaborator.length; i++){
        const collaborator={
          id: this.collaborator[i].id,
          nameSurname: this.collaborator[i].name + ' '+ this.collaborator[i].surname
        }
        collaboratorList.push(collaborator)
      }
      return collaboratorList
    }
  },
  methods: {
    resetProject(){
      this.payload.projectId = 'all'
      this.payload.phase = 'all'
    },
    onChange(event) {
      switch (event.target.className) {
        case 'collaborator-input':
          this.payload.collaboratorId = event.target.value
            break
        case  'month-selector':
          this.payload.month = event.target.value
            break
        case 'phase-selector':
          this.payload.phase = event.target.value
      }
      this.payload.agenceId = this.$store.state.auth.currentAgence._id
    },

    processValue(result) {
      if (result.length === 0) {
        this.payload.projectId = ""
      }else{
        this.payload.projectId = result[0]._id
        this.getPhases()
      }
    },

    async getPhases(){
      if(this.projectId === ""){
        console.log("need to select a project")
      }else{
        await this.$axios.get('/phases/getByProjet/' + this.payload.projectId + "/" + this.$store.state.auth.currentAgence._id)
            .then(response => this.phaseList = response.data)
            .catch(e => this.alert(e))
      }
    },
    async loadYear(){
      const promiseRH = this.$axios.get('agence/getByAgenceRhByYear/' + this.$store.state.auth.currentAgence._id + '/' + this.year)
          .then(response => {
            this.$emit('analyseRH', response.data)
            this.collaborator = response.data.rh
            //console.log("analyseRH")
            //console.log(response.data.rh)
          })
          .catch(err => this.alert(err))

      const promiseCA = this.$axios.get('agence/getByAgenceCaByYear/' + this.$store.state.auth.currentAgence._id + '/' + this.year)
          .then(response => {
            this.$emit('analyseCA', response.data)
            //console.log("analyseCA")
            //console.log(response.data)
          })
          .catch(err => this.alert(err))

      const promiseNotes = this.$axios.get('agence/getByAgenceNotesPrestasByYear/' + this.$store.state.auth.currentAgence._id + '/' + this.year)
          .then(response => {
            this.$emit('analyseNotes', response.data)
            //console.log("analyseNotes")
            //console.log(response.data)
            //console.log("--")
          })
          .catch(err => this.alert(err))

      const promiseOps = this.$axios.get('projets/byAgence/' + this.$store.state.auth.currentAgence._id)
          .then(response=>{
            this.opsList = response.data
            //console.log("opsList")
            //console.log(response.data)
          })
          .catch(err => this.alert(err))
      const promiseAvgNonFacturable = this.$axios.get('agence/getAgenceAvgNonFacturable/' + this.$store.state.auth.currentAgence._id+ '/' + this.year)
          .then(response=>{
            console.log('blyat')
            this.$emit('avgNonFacturable', response.data)
          })
          .catch(err => this.alert(err))

      await Promise.all([promiseRH, promiseCA, promiseNotes, promiseOps,promiseAvgNonFacturable])

      this.$emit('fullyLoaded', true)
    },

    processPayload(){
      let url = ''
      url += "/" + this.$store.state.auth.currentAgence._id + "/" + this.year
      if(this.payload.month != null){
        url += "/" + this.payload.month
      }else{
        url += "/" + "all"
      }
      if(this.payload.projectId != null){
        url += "/" + this.payload.projectId
      }else{
        url += "/" + "all"
      }
      if(this.payload.phase != null){
        url += "/" + this.payload.phase
      }else{
        url += "/" + "all"
      }
      if(this.payload.collaboratorId != null){
        url += "/" + this.payload.collaboratorId
      }else{
        url += "/" + "all"
      }
      //console.log ('payload: ' +url)
      this.loadFilterData(url)
    },

    async loadFilterData(payload){
// console.log(payload) // /6180ff50e983ca195849abc5/2024/all/62b95d29826419001857e4fd/all/all
      this.$emit('fullyLoaded', false)
      const promiseRH = this.$axios.get("agence/getByAgenceRhByYear" + payload)
          .then(response => {
            this.$emit('analyseRH', response.data)
            this.collaborator = response.data
          })
          .catch(err => this.alert(err))
      const promiseCa = this.$axios.get('agence/getByAgenceCaByYear' + payload)
      .then(response => {
        this.$emit('analyseCA', response.data)
      })
      const promiseNotes = this.$axios.get('agence/getByAgenceNotesPrestasByYear' + payload)
      .then(response => {
        this.$emit('analyseNotes', response.data)
      })
      const promiseAvgNonFacturable = this.$axios.get('agence/getAgenceAvgNonFacturable' + payload)
          .then(response=>{
            this.$emit('avgNonFacturable', response.data)
          })
      await Promise.all([promiseRH, promiseCa, promiseNotes,promiseAvgNonFacturable])
      this.$emit('fullyLoaded', true)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/main.scss';
  .agenceFilter{
    display: flex;
    flex-direction: column;
    @include myBlock;
    padding: 15px;
    margin: 15px 0 0 0;
    max-width: 171px;

    &__title{
      @include myFont;
      color: $main;
      font-size: 13px;
      font-weight: 600;
      margin: 0 0 10px 0;
    }

    &__labels{
      @include myFont;
      color: $black-bolder;
      font-size: 11px;
    }

    & select{
      margin: 0 0 5px 0;
    }
    & .search{
      margin: 0 0 5px 0;
    }

    &__button{
      @include myButton;
      margin: 15px 0 0 0;
    }
  }
</style>
